import { useState } from 'react'

export default function useHomeState() {
    const [showAnnouncement, setShowAnnouncement] = useState(false);

    return {
        showAnnouncement,
        updateShowAnnouncement: setShowAnnouncement
    }
}